import React from 'react';
import { withScrollDisable } from '../hocs/scroll';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const Modal = ({ open, children, onClose, className, noClose = false }) => {
    return (
        <React.Fragment>
            <div className={`ckp-modal ${open ? 'is-open' : ''} ${className || ''}`}>
                <div className="ckp-modal-content">
                    {noClose ? null : (
                        <IconButton className="ckp-modal-close" onClick={onClose} color="inherit">
                            <CloseIcon />
                        </IconButton>
                    )}
                    <div className="ckp-modal-body">{children}</div>
                </div>
            </div>
            <div className="ckp-modal-overlay" onClick={onClose} />
        </React.Fragment>
    );
};

export default withScrollDisable(Modal);
